// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../../utils/axiosInstance";

// export const mmtc_redeemApi = createAsyncThunk("mmtc_redeem", async () => {
//   const response = await axiosInstance.get("/mmtc_redeem");
//   return response.data;
// });

// const mmtc_redeemSlice = createSlice({
//   name: "mmtc_redeem",
//   initialState: {
//     mmtc_redeem: [],
//     errors: [],
//     loading: false,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(mmtc_redeemApi.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(mmtc_redeemApi.fulfilled, (state, action) => {
//         state.mmtc_redeem = action.payload;
//         state.loading = false;
//       })
//       .addCase(mmtc_redeemApi.rejected, (state, action) => {
//         state.errors.push(action.error.message);
//         state.loading = false;
//       });
//   },
// });

// export default mmtc_redeemSlice.reducer;


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const mmtc_redeemApi = createAsyncThunk("mmtc_redeem", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/mmtc_redeem",{ params });
  return response.data;
});

const mmtc_redeemSlice = createSlice({
  name: "mmtc_redeem",
  initialState: {
    mmtc_redeem: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mmtc_redeemApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mmtc_redeemApi.fulfilled, (state, action) => {
        state.mmtc_redeem = action.payload;
        state.loading = false;
      })
      .addCase(mmtc_redeemApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mmtc_redeemSlice.reducer;
